module.exports = __webpack_public_path__ + "static/media/gallery19.22210f70.png";